import Ajax from 'js/utils/ajax/ajax';

export const getOrderEvents = (trackingReference: string) =>
  Ajax.get(`/orders/v1/${trackingReference}/events`);
